<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "Predictions"
    }
</script>

<style scoped>

</style>
